import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var FlagBanner = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.125 16.875V3.75H17.5L13.75 8.4375L17.5 13.125H3.125", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }))); };

export { FlagBanner as default };
//# sourceMappingURL=FlagBanner.js.map
